import { Link } from "react-router-dom";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories, videos } from "@/mocks/videos";

const featuredVideos = videos.slice(0, 6);
const hotVideos = videos.slice(6, 10);
const latestVideos = videos.slice(10, 16);

const siteUrl = "https://tplogy.cn";
const pageTitle = "九色视频 - 海量高清视频资源一站式平台";
const pageDesc = "九色视频是您最值得信赖的视频内容平台，汇聚海量高清视频资源，涵盖多元内容分类，极速播放体验，随时随地畅享优质视频内容，立即访问九色视频，开启您的精彩视频之旅。";
const pageKeywords = "九色视频,九色视频高清,九色视频在线观看,九色视频资源,九色视频平台,高清视频播放,在线视频资源";

const faqItems = [
  { q: "九色视频需要付费吗？", a: "九色视频提供大量免费高清视频内容，部分独家内容和超高清资源可能需要会员订阅。我们坚持为用户提供最具性价比的视频观看体验，免费用户同样可以享受海量优质内容。" },
  { q: "九色视频支持哪些设备观看？", a: "九色视频全面支持PC端、手机端、平板电脑以及智能电视等多种设备观看。您可以在任何时间、任何地点通过浏览器访问九色视频，畅享极速高清播放体验。" },
  { q: "九色视频的视频画质如何？", a: "九色视频平台提供从标清到4K超高清的多档画质选择，采用先进的视频编码技术和全球CDN加速网络，确保您在各类网络环境下都能获得流畅清晰的播放体验。" },
  { q: "如何在九色视频上找到想看的内容？", a: "您可以通过首页的智能推荐、分类导航浏览，或使用搜索功能输入关键词精准查找。九色视频的智能推荐算法会根据您的观看偏好，为您推送最符合口味的精彩内容。" },
  { q: "九色视频的内容更新频率是多少？", a: "九色视频内容团队每日更新海量视频资源，热门影视剧集实时同步更新，综艺节目和纪录片持续上新，确保您始终能够看到最新、最热的视频内容。" },
];

const schemaData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "九色视频",
    "url": siteUrl,
    "description": pageDesc,
    "logo": `${siteUrl}/logo.png`,
    "sameAs": ["https://weibo.com/jiuseshipin", "https://space.bilibili.com/jiuseshipin"],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "九色视频",
    "url": siteUrl,
    "description": pageDesc,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": pageDesc,
    "url": siteUrl,
    "isPartOf": { "@type": "WebSite", "name": "九色视频", "url": siteUrl },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": { "@type": "Answer", "text": item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={siteUrl}
        ogImage={`${siteUrl}/og-image.jpg`}
        schemaData={schemaData}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20background%20with%20flowing%20gradients%20of%20deep%20charcoal%20and%20rich%20crimson%20tones%2C%20soft%20dramatic%20lighting%20like%20a%20movie%20theater%20screen%20glow%2C%20elegant%20geometric%20texture%2C%20no%20text%2C%20no%20people%2C%20atmospheric%20and%20sophisticated&width=1920&height=900&seq=hero-bg-jiuse-01&orientation=landscape)`,
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
              海量高清视频资源
              <br />
              <span className="text-primary-400">一站式畅享平台</span>
            </h1>
            <p className="text-lg md:text-xl text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
              九色视频汇聚全网优质内容，电影、电视剧、综艺、动漫、纪录片等多元分类应有尽有，极速播放体验，随时随地开启精彩视频之旅。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/dianying"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-all duration-300 whitespace-nowrap"
              >
                立即探索 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full text-base backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg mx-auto">
              {[
                { num: "10万+", label: "视频资源" },
                { num: "5000万+", label: "活跃用户" },
                { num: "99.9%", label: "播放成功率" },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.num}</div>
                  <div className="text-sm text-white/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-s-line text-white/40 text-2xl"></i>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                探索精彩内容分类
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto">
                九色视频涵盖九大内容分类，无论您喜欢什么类型的视频，都能在这里找到心仪之作。
              </p>
            </div>

            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 group cursor-pointer"
                >
                  <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Videos */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                  精选推荐
                </h2>
                <p className="text-foreground-600">编辑团队为你精心挑选的高品质视频内容</p>
              </div>
              <Link
                to="/category/dianying"
                className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
              {featuredVideos.map((video) => {
                const cat = categories.find((c) => c.id === video.category);
                return (
                  <Link
                    key={video.id}
                    to={`/article/${video.id}`}
                    className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:translate-y-[-4px] cursor-pointer"
                  >
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                        <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0">
                          <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                        </div>
                      </div>
                      <span className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 text-white text-xs rounded-md font-medium">
                        {video.duration}
                      </span>
                    </div>
                    <div className="p-5">
                      <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {video.title}
                      </h3>
                      <div className="flex items-center gap-3 text-xs text-foreground-500">
                        {cat && (
                          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${cat.color}`}>
                            {cat.name}
                          </span>
                        )}
                        <span><i className="ri-eye-line mr-1"></i>{video.views}</span>
                        <span><i className="ri-star-fill text-accent-500 mr-0.5"></i>{video.rating}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>

            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category/dianying"
                className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                为什么选择九色视频？
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto">
                我们致力于为你提供最优质的高清视频观看体验
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: "ri-4k-line",
                  title: "极致高清画质",
                  desc: "支持从标清到4K超高清多档画质选择，采用先进编码技术，确保每一帧画面都清晰细腻、色彩饱满。",
                },
                {
                  icon: "ri-flashlight-line",
                  title: "极速秒播体验",
                  desc: "全球CDN加速网络覆盖，智能码率自适应技术，任何网络环境下都能享受零缓冲、秒开播的流畅体验。",
                },
                {
                  icon: "ri-stack-line",
                  title: "海量内容资源",
                  desc: "每日更新海量视频资源，涵盖电影、电视剧、综艺、动漫、纪录片等九大分类，满足各类用户需求。",
                },
                {
                  icon: "ri-smartphone-line",
                  title: "全终端适配",
                  desc: "完美适配PC、手机、平板及智能电视，跨设备同步观看记录，随时随地无缝切换，畅享不间断体验。",
                },
                {
                  icon: "ri-shield-check-line",
                  title: "安全可靠保障",
                  desc: "严格的内容审核机制和版权保护体系，采用SSL加密传输，保障您的隐私安全和观看体验。",
                },
                {
                  icon: "ri-user-heart-line",
                  title: "智能精准推荐",
                  desc: "基于AI算法的智能推荐引擎，深度分析您的观影偏好，精准推送最符合您口味的优质内容。",
                },
              ].map((feat) => (
                <div key={feat.title} className="flex gap-5 p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors duration-300">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${feat.icon} text-xl text-primary-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-950 mb-2">{feat.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                  热门推荐
                </h2>
                <p className="text-foreground-600">全网用户都在看的爆款视频</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
              {hotVideos.map((video) => {
                const cat = categories.find((c) => c.id === video.category);
                return (
                  <Link
                    key={video.id}
                    to={`/article/${video.id}`}
                    className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:translate-y-[-4px] cursor-pointer"
                  >
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <span className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 text-white text-xs rounded-md font-medium">
                        {video.duration}
                      </span>
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {video.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                        {cat && (
                          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${cat.color}`}>
                            {cat.name}
                          </span>
                        )}
                        <span><i className="ri-eye-line mr-1"></i>{video.views}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                  最新上线
                </h2>
                <p className="text-foreground-600">每日更新的最新视频内容</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
              {latestVideos.map((video) => {
                const cat = categories.find((c) => c.id === video.category);
                return (
                  <Link
                    key={video.id}
                    to={`/article/${video.id}`}
                    className="group flex gap-4 bg-background-100 rounded-2xl p-4 transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
                  >
                    <div className="relative w-40 h-24 flex-shrink-0 rounded-xl overflow-hidden">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <span className="absolute bottom-1.5 right-1.5 px-1.5 py-0.5 bg-black/70 text-white text-[10px] rounded font-medium">
                        {video.duration}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {video.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                        {cat && (
                          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${cat.color}`}>
                            {cat.name}
                          </span>
                        )}
                        <span><i className="ri-eye-line mr-1"></i>{video.views}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                常见问题
              </h2>
              <p className="text-foreground-600">关于九色视频，你想知道的都在这里</p>
            </div>

            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group bg-background-50 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h4 className="font-heading font-semibold text-foreground-900 text-base pr-4">
                      {item.q}
                    </h4>
                    <div className="w-7 h-7 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-300">
                      <i className="ri-add-line text-foreground-600"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div
              className="relative rounded-3xl overflow-hidden p-10 md:p-16 text-center"
              style={{
                backgroundImage: `url(https://readdy.ai/api/search-image?query=Abstract%20warm%20dark%20cinematic%20texture%20with%20soft%20flowing%20gradients%20of%20deep%20crimson%20and%20charcoal%2C%20elegant%20theater%20curtain%20aesthetic%2C%20subtle%20geometric%20patterns%2C%20atmospheric%20and%20luxurious&width=1400&height=500&seq=cta-bg-jiuse-02&orientation=landscape)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/60"></div>
              <div className="relative z-10">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
                  即刻开启你的精彩视频之旅
                </h2>
                <p className="text-white/70 mb-8 max-w-lg mx-auto">
                  加入九色视频，海量高清视频资源等你来发现。随时随地，畅享极致观影体验。
                </p>
                <Link
                  to="/category/dianying"
                  className="inline-flex items-center px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-all duration-300 whitespace-nowrap"
                >
                  立即开始探索 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}